import { styled } from '@mui/material';

export default styled('div')({
  display: 'flex',
  flexDirection: 'column',
  margin: 48,
});
